import { RootStore, OrdersStore, OrderWithAudit, SEARCH_TYPES } from '../../../types';

export const selectOrdersPage = (store: RootStore): OrdersStore => (store.orders);

export const selectOrderById = (store: RootStore, id: number): OrderWithAudit | undefined => (store.orders.byId[id]);

export const selectOrderSearch = (store: RootStore): { type: SEARCH_TYPES, value: string, isShown: boolean } => store.orders.search;
